<div class="invitation-page">
  <div class="invitation-card">
    <div class="brand">Collary</div>

    @switch (state) {
      @case ('loading') {
        <app-loader></app-loader>
      }

      @case ('error') {
        <div class="title">Invitation indisponible</div>
        <p class="text">{{ errorMessage }}</p>
        <app-button text="Aller à la connexion" innerClass="w-100 mt-3" routerLink="/login"></app-button>
      }

      @case ('done') {
        <div class="title">Compte activé 🎉</div>
        <p class="text">
          Votre compte <b>{{ invitation?.email }}</b> est prêt. À chaque connexion, un code de vérification
          vous sera envoyé par e-mail pour sécuriser l'accès.
        </p>
        <app-button text="Se connecter" innerClass="w-100 mt-3" (handleClick)="goToLogin()"></app-button>
      }

      @case ('form') {
        <div class="title">Bienvenue{{ invitation?.firstName ? ' ' + invitation.firstName : '' }} !</div>
        <p class="text">
          Vous avez été invité(e) à rejoindre
          <b>{{ invitation?.agencyName || "votre organisation" }}</b> sur Collary
          en tant que <b>{{ invitation?.roleLabel }}</b>.
          Choisissez votre mot de passe pour activer votre compte.
        </p>

        <div class="identity">
          <div class="fs-13 text-neutral-dark-grey">Identifiant de connexion</div>
          <div class="fs-16 fw-6">{{ invitation?.email }}</div>
        </div>

        <div [formGroup]="form" (keyup.enter)="submit()">
          <app-custom-input label="Mot de passe" type="password" positionIcon="right"
                            [parentForm]="form" controlName="password" [required]="true"
                            innerClass="mt-px-16"></app-custom-input>
          <ul class="rules">
            @for (rule of rules; track rule.label) {
              <li [class.ok]="rule.test(password)">{{ rule.test(password) ? '✓' : '•' }} {{ rule.label }}</li>
            }
          </ul>

          <app-custom-input label="Confirmer le mot de passe" type="password" positionIcon="right"
                            [parentForm]="form" controlName="confirmation" [required]="true"
                            [errorMessage]="mismatch ? 'Les deux mots de passe ne correspondent pas.' : ''"
                            innerClass="mt-px-8"></app-custom-input>
        </div>

        <div class="required fs-13 mt-px-12" *ngIf="submitError">{{ submitError }}</div>

        <app-button text="Activer mon compte" innerClass="w-100 mt-3"
                    [loading]="submitting" [disabled]="form.invalid || submitting"
                    (handleClick)="submit()"></app-button>
      }
    }
  </div>
</div>
